import React, {useState, useEffect} from "react";
import NotifactionCSS from "./NotificationActions.module.css"
// import NotificationListItem from "../notification_listitem/NotificationListItem";
import nli from "../notification_listitem/NotificationListItem.module.css";
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import { values } from "lodash";
import { getOrders, adminToken, editNotifications } from '../../../../network';

const Wrapper = styled.div`
   position: relative;
    margin-bottom: var(--space-12);
    top: var(--space-10);
    height: 81px;
    width: -webkit-fill-available;
    background-color: ${props => props.new ? 'var(--color-gray-100)' : 'var(--color-white)'};;
    box-shadow: ${props => props.new ? "var(--shadow-base)" : "none"};
    border-radius: 4px;
    border: ${props => props.selected ? '2px solid var(--color-blue-500)' : '1px solid var(--color-gray-400)'};
    cursor: pointer;

    overflow: hidden;


`;

const Container = styled.div`

    padding: var(--space-12);
    overflow: hidden;


    .header{
        padding-left: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .liwelement{
        font-family: Inter,sans-serif;
        font-weight: 600;
        font-size: var(--font-14);
        color: #6E7B87;
        left: var(--space-36);
        top: var(--space-12);
        left: 2.2rem;
    }

    .liwelement_two{
        font-family: Inter,sans-serif;
        font-weight: 600;
        font-size: var(--font-24);
        font-size: var(--font-14);
        color: #6E7B87;
    }

    > img{
        margin-right: var(--space-12);
        position: absolute;
        top: var(--space-12);
        left: var(--space-12);
    }

    > p {
        font-family: Inter,sans-serif;
        font-weight: 500;
        font-size: var(--space-14);
        width: 22rem;
        padding: var(--space-8);
        color: #6E7B87;
        font-size: var(--font-14);
        line-height: var(--space-14);
        padding-left: 2rem;
    }

    .imagediv{
        position: absolute;
        left: var(--space-14);
        top: var(--space-32);
    }
`;

function NotificationActions({notification, setInfo, setOrder}) {

    const [read, setRead] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [ellipsis, setEllipsis] = useState('');
    const [values, setValues] = useState([]);
    let order = [];

    const markAsRead = (id,value) => {
        editNotifications(adminToken,id,value);
        setRead(true);
    }

    const checkRead = (val) => {
        if(val === false){
            setRead(false);
        }else{
            setRead(true);
        }
    }

    const showOrders = (id) => {
        getOrders(adminToken,id)
            .then(result => {
                setOrder(result);
                
            })
            .catch(error => console.error(error));
       
    };

    const checkType = (type) => {
        if(type === 'order'){
            return "New Order Received";
           
        } else if(type === 'contact'){
            return "Customer Message Received";
        }
    }

    const checkIcon = (type) => {
        if(type === 'order'){
            return "/icons/ellipse_purple.svg";
           
        } else if(type === 'contact'){
            return "/icons/ellipse_green.svg";
        }
    }

    const checkFlagged = (flag) => {
        if(flag){
            return "/icons/flagged.svg";
           
        } 
    }

    const sliceText = (text) => {
        if(text.length > 90){
            let str = text.slice(0,96);
            return str+"...";
        }else{
            return text;
        }
      
    }


    useEffect(() => {
  
        console.log(values);

    },[values]);

    return (
        <>
            <div className={NotifactionCSS.grid_container}>
                <div className={NotifactionCSS.grid_item1}>
                    <div className={NotifactionCSS.input}>
                        <input placeholder="Search..." />
                        <img src="/icons/search.svg"></img></div>
                </div>
                <div className={NotifactionCSS.grid_item2}>
                    <span className={NotifactionCSS.iwrapper}>Sort by</span>
                    <div className={NotifactionCSS.sortby}></div>
                </div>
                <div className={NotifactionCSS.grid_item3}>
                    <div style={{overflowY: "auto", height: "83vh",display:"flex",flexDirection:"column",alignItems:"center"}}>
                    {Object.values(notification).map((values,index) => {
                        
                        return <Wrapper key={index} selected={selectedIndex === index}  new={values.read}    onClick={() => {
                            markAsRead(values.id,{"read":true})
                            if (selectedIndex !== index) {
                                setSelectedIndex(index);
                                setInfo(values);
                                if(values.order_id !== null){
                                    showOrders(values.order_id);
                                }
                                
                            }
                            else if(selectedIndex === 0){
                                setSelectedIndex(0);
                                setInfo(values);
                            }
                            else setSelectedIndex(-1);
                        }}>
                            <Container>
                                <img src={checkIcon(values.type)}></img>
                        
                                    <div className="header">
                                        <span className="liwelement">{checkType(values.type)}</span><span className="liwelement_two">{new Date(values.created).toDateString()}</span>
                                    </div>
                                    <p style={{textOverflow:ellipsis}}>
                                        {sliceText(values.notification_content)}
                                    </p>
                                
                                <div className="imagediv">
                                    <img src={checkFlagged(values.flagged)}></img>
                                </div>
                            </Container>
                        </Wrapper>
                       
})}
                     
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state,props) => ({
    notification: state.notification,
    setInfo: props.setInfo,
    setOrder: props.setOrder
});
 //const mapDispatchToProps = {newOrderNotificationAction};

export default connect(mapStateToProps,null)(NotificationActions);